'use client'

import { ButtonPrimary } from 'fukku/Button/Primary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import styles from './DetailsError.module.scss'
import text from 'fukku/styles/texts.module.scss'

export function DetailsError({
	retryCallback,
}: {
	readonly retryCallback?: () => void
}) {
	const { t } = useLabels()

	return (
		<div className={styles.container}>
			<p className={text.bodyL}>{t('myPurchases.errorAll.bodycopy.guest')}</p>
			<ButtonPrimary onClick={retryCallback} className={styles.button}>
				{t('myPurchases.errorAll.retry.button')}
			</ButtonPrimary>
		</div>
	)
}
